import { ref, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { useCookie } from '#app'

declare global {
  interface Window {
    dataLayer: any[]
  }
}

export const useAffiliateTracking = () => {
  const route = useRoute()
  const awcValue = ref<string | null>(null)
  const affiliateCookie = useCookie('affiliate-awc', {
    maxAge: 60 * 60 * 24 * 30, // 30 days in seconds
  })
  let originalPush: typeof window.dataLayer.push

  const handleConsentChange = (event: any) => {
    if (
      event.event === 'iubenda_consent_given' ||
      event.event === 'iubenda_consent_given_purpose_5' // marketing consent
    ) {
      if (awcValue.value) {
        affiliateCookie.value = awcValue.value
      }
    } else if (event.event === 'iubenda_consent_rejected') {
      affiliateCookie.value = null
    }
  }

  onMounted(() => {
    const awc = route.query.awc as string
    if (awc) {
      awcValue.value = awc
    }

    // Initialize dataLayer if it doesn't exist
    if (!window.dataLayer) {
      window.dataLayer = []
    }

    // Listen for dataLayer events
    originalPush = window.dataLayer.push
    window.dataLayer.push = function (...args: any[]) {
      const event = args[0]
      if (event && typeof event === 'object') {
        handleConsentChange(event)
      }
      return originalPush.apply(this, args)
    }
  })

  onUnmounted(() => {
    // Restore original dataLayer.push if it exists
    if (originalPush && window.dataLayer) {
      window.dataLayer.push = originalPush
    }
  })

  return {
    awcValue,
    affiliateCookie,
  }
}
